import clsx from 'clsx';

import { ButtonElement } from './types';

const Button = ({ children, className, disabled, ...props }: ButtonElement) => {
  const baseClasses =
    'cursor-pointer rounded-lg p-2 text-md transition-transform flex items-center justify-center disabled:cursor-not-allowed hover:cursor-pointer';

  return (
    <button
      {...props}
      disabled={disabled}
      className={clsx(baseClasses, disabled && 'opacity-45', className)}
      style={{
        backgroundColor: 'var(--background)',
        color: 'var(--foreground)',
      }}
    >
      {children}
    </button>
  );
};

export default Button;
